import { inject, Injectable } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiResponse } from './common/types';
import { LandingPageData } from './types/landing.types';

@Injectable({ providedIn: 'root' })
export class LandingService {

  private readonly apiService = inject(ApiService);

  fetchLandingPage(): Observable<LandingPageData> {
    return this.apiService.handleRequest<ApiResponse<LandingPageData>>({
      method: 'GET',
      endpoint: '/landing/categories',
      apiV3: true,
    }).pipe(
      filter(response => !!response.data),
      map(response => ({
        heroBanner: response.data.heroBanner ?? null,
        categories: [...response.data.categories].sort((a, b) => a.sequence - b.sequence),
      }))
    );
  }
}
